/**
 * SxaAssessmentLandscapeTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';
import PropTypes from "prop-types";

import {withStyles} from "@material-ui/core";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';

// Sxa Components
import SxaAssessmentInputTile from './SxaAssessmentInputTile';
import SxaAssessmentResultsTile from './SxaAssessmentResultsTile';
import SxaAssessmentStartDialog from './SxaAssessmentStartDialog';

// custom font styles
const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            'Open Sans, sans-serif',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
});

const styles = theme => ({
    appBarBottom: {
        top: 'auto',
        bottom: 0,
    },
    toolbar: {
        alignItems: 'center',
        justifyContent: 'space-between',
    },
});

class SxaAssessmentLandscapeTile extends React.Component {
    constructor(props) {
        super(props);

        //console.log("Assessment Landscape init; ass = " + props.ass.oid);

        // Assign A ref to state for refresh
        this.state = {
            ass: props.ass,
            progstate: props.ass.progressState
        };
    }

    // Callback function used by child to signal A Start
    signalStart = () => {
        // Pre-Condition:
        // (A) progstate is NOT_STARTED - defensive

        //console.log("Assessment_Landscape.signalStart()");

        // Signal up to Root tile
        this.props.signalStart();
    }

    // Callback function used by child to signal Q-score change
    signalScoreChange = () => {
        //console.log("Assessment_Landscape.signalScoreChange()");

        // Signal up to Root tile
        this.props.signalScoreChange();
    }

    // Callback function used by child to signal Q change (nav)
    signalQChange = (q) => {
        // Check for Q already set
        var currQ = this.state.ass.currentQuestion;
        if (currQ.oid === q.oid) {
            //console.log("A-Landscape.signalQChange(): current Question was NOT changed; Q = " + q.oid);

            // Signal the root tile in case stale
            this.props.signalQChange(q);

            return;
        }

        // Debug trace
        //console.log("A-Landscape.signalQChange(); new Q id = " + q.oid +
        //    "; PA id = " + q.paId +
        //    "; D id = " + q.dId
        //);

        // Update the landscape A
        // FIXME - rely on this bening done in root only? TBD
        var currA = this.state.ass;
        currA.currentQuestion = q;
        currA.currentProcessAreaID = q.paId;
        currA.currentDimensionID = q.dId;
        this.setState({ ass: currA} );

        // Signal the root tile
        this.props.signalQChange(q);
    }

    updateResults = (newA) => {
        this.setState({ass: newA});

        // Pass-through call from root to results
        this.ares.updateResults(this.state.ass);
    }

    signalAChange  = (a) => {
        //console.log("Assessment_Landscape.signalAChange(); new A id = " + a.oid);

        this.setState({ass: a});

        // Update results panel
        if (this.ares) {
            this.ares.updateResults(a);
        }

        // Update input panel (since only shallow check by Rect on tile)
        if (this.ain) {
            this.ain.handleAChange(a);
        }
    }

    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <React.Fragment>
                    {this.state.ass ? (
                        <div style={{background: '#e6eaee',
                            padding: 24,
                            minHeight: 600}}>
                            <Grid container spacing={0} style={{padding: 0}}
                                  direction="row" justify="space-evenly" alignItems="stretch">
                                <Grid item xs={9} sm={9} lg={9} xl={9}>
                                    <SxaAssessmentInputTile ass={this.state.ass}
                                                            signalScoreChange={this.signalScoreChange}
                                                            signalQChange={this.signalQChange}
                                                            ref={(ain) => { this.ain = ain; }}
                                    />
                                </Grid>
                                <Grid item xs={3} sm={3} lg={3} xl={3}>
                                    <SxaAssessmentResultsTile ass={this.state.ass}
                                                              innerRef={(ares) => {
                                                                  this.ares = ares;
                                                              }}
                                    />
                                </Grid>
                            </Grid>
                            <SxaAssessmentStartDialog progstate={this.state.ass.progressState}
                                                      signalStart={this.signalStart}
                                                      innerRef={(startd) => {
                                                          this.startd = startd;
                                                      }}
                            />
                        </div>
                    ) : "No Assessment found"}
                </React.Fragment>
            </MuiThemeProvider>
        )
    }
}

SxaAssessmentLandscapeTile.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SxaAssessmentLandscapeTile);